import { Component } from '@angular/core';
import { MethodBase } from '../base/base.component';
import { FormBuilder, Validators } from '@angular/forms';
import { PasscodeEmailAuthMethodViewModel } from '../../../../services/identity';

@Component({
  selector: 'app-method-passcode-email',
  standalone: false,
  templateUrl: './passcode-email.component.html',
  styleUrl: './passcode-email.component.scss'
})
export class PasscodeEmailComponent extends MethodBase {
  private passcodeEmailMethod: PasscodeEmailAuthMethodViewModel

  constructor(
    private fb: FormBuilder
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();
    if (!this.form.value.emailAddress && this.options.user.email) {
      this.form.controls['emailAddress'].setValue(this.options.user.email);
    }
  }


  setup(): void {
    this.passcodeEmailMethod = this.method as PasscodeEmailAuthMethodViewModel;
    this.form = this.fb.group({
      emailAddress: [this.passcodeEmailMethod.emailAddress, [Validators.required, Validators.email]]
    });
  }

  cancel(): void {
    this.setup();
  }

  override getMethod(): PasscodeEmailAuthMethodViewModel {
    this.passcodeEmailMethod.emailAddress = this.form.value.emailAddress;
    return this.passcodeEmailMethod;
  }
}
